var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-field',{staticClass:"timezones",attrs:{"value":_vm.value,"items":_vm.timezones,"empty-option":false,"disabled":_vm.disabled},on:{"selected":_vm.valueChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }